import { createUseStyles } from 'react-jss';

const useSvgIconStyles = createUseStyles(
  {
    root: {
      display: 'inline-block',
      overflow: 'hidden',
      userSelect: 'none',
      verticalAlign: 'top',

      '& > svg': {
        display: 'block',
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
      },
    },
  },
  {
    name: 'svg-icon',
  },
);

export default useSvgIconStyles;
